export default function Layout({ children }) {
  return (
    <div className="layout">
      <header className="header">
        <div className="header-brand">
          <span className="header-logo">🥗</span>
          <div>
            <h1 className="header-title">Rê Leve IA</h1>
            <p className="header-subtitle">Chatbot de venda, relacionamento e acompanhamento calórico</p>
          </div>
        </div>
        <span className="header-badge">Protótipo Acadêmico</span>
      </header>
      <main className="main-content">{children}</main>
      <footer className="footer">
        Protótipo funcional para apresentação acadêmica — IA para Negócios 2026.1 · Rê Leve Recife
      </footer>
    </div>
  );
}
